export const RESPONSES_SET_FORM = 'RESPONSES_SET_FORM';

export const RESPONSES_SET_RESPONSES = 'RESPONSES_SET_RESPONSES';

export const RESPONSES_SET_NO_RESPONSES = 'RESPONSES_SET_NO_RESPONSES';

export const RESPONSES_SET_RECIPIENT_COUNT = 'RESPONSES_SET_RECIPIENT_COUNT';

export const RESPONSES_SET_AGGREGATED = 'RESPONSES_SET_AGGREGATED';

export const RESPONSES_RESPONSES_LOADING = 'RESPONSES_RESPONSES_LOADING';

export const RESPONSES_RESPONSES_LOAD_COMPLETE ='RESPONSES_RESPONSES_LOAD_COMPLETE';

export const RESPONSES_FORM_LOADING = 'RESPONSES_FORM_LOADING';

export const RESPONSES_FORM_LOAD_COMPLETE ='RESPONSES_FORM_LOAD_COMPLETE';

export const RESPONSES_AGGREGATED_LOADING = 'RESPONSES_AGGREGATED_LOADING';

export const RESPONSES_AGGREGATED_LOAD_COMPLETE ='RESPONSES_AGGREGATED_LOAD_COMPLETE';

export const RESPONSES_SET_DASHBOARD_REPORT = 'RESPONSES_SET_DASHBOARD_REPORT';

export const RESPONSES_DASHBOARD_REPORT_LOADING = 'RESPONSES_DASHBOARD_REPORT_LOADING';

export const RESPONSES_DASHBOARD_REPORT_LOAD_COMPLETE ='RESPONSES_DASHBOARD_REPORT_LOAD_COMPLETE';

export const RESPONSES_SURVEY_LOADING = 'RESPONSES_SURVEY_LOADING';

export const RESPONSES_SURVEY_LOAD_COMPLETE ='RESPONSES_SURVEY_LOAD_COMPLETE';

export const RESPONSES_ORGANIZATION_LOADING = 'RESPONSES_ORGANIZATION_LOADING';

export const RESPONSES_ORGANIZATION_LOAD_COMPLETE ='RESPONSES_ORGANIZATION_LOAD_COMPLETE';

export const RESPONSES_CLEAR_DATA = 'RESPONSES_CLEAR_DATA';

export const RESPONSES_CHANGE_VIEW = 'RESPONSES_CHANGE_VIEW';

export const RESPONSES_CHANGE_RESPONSE_TYPE_TAB = 'RESPONSES_CHANGE_RESPONSE_TYPE_TAB';

export const RESPONSES_SELECT_RESPONSE = 'RESPONSES_SELECT_RESPONSE';

export const RESPONSES_SET_SURVEY_START_DATE = 'RESPONSES_SET_SURVEY_START_DATE';

export const RESPONSES_SET_RESPONSE_COUNT = 'RESPONSES_SET_RESPONSE_COUNT';

export const RESPONSES_SET_ACTUAL_RESPONSE_COUNT = 'RESPONSES_SET_ACTUAL_RESPONSE_COUNT';

export const RESPONSES_CLEAR_RESPONSE_DATA = 'RESPONSES_CLEAR_RESPONSE_DATA';

export const views = {
    aggregate: 'aggregate',
    table: 'table',
    individual: 'individual',
    dashboard: 'dashboard'
};

export const responseTabs = {
    responses: 'responses',
    noResponse: 'no response'
};
